"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeblabOverrideHeader = exports.isValidCookie = exports.getPlatformType = exports.getDeviceType = exports.writeShoppingPortalResponseHeaders = void 0;
const trim_1 = __importDefault(require("lodash/trim"));
const models_1 = require("../../models");
const http_1 = require("../http");
const writeShoppingPortalResponseHeaders = (res, params) => {
    res.setHeader(http_1.HTTPHeaders.ContentType, params.contentType);
    res.setHeader('boundary', params.delimiter);
    res.setHeader(models_1.ShoppingPortalHeadersEnum.PageNavTemplate, params.navTemplateType);
    if (params.navStoreName) {
        res.setHeader(models_1.ShoppingPortalHeadersEnum.PageNavStore, params.navStoreName);
    }
    if (params.navNodeId) {
        res.setHeader(models_1.ShoppingPortalHeadersEnum.PageNavNode, params.navNodeId);
    }
    if (params.pageType) {
        res.setHeader(models_1.ShoppingPortalHeadersEnum.PageType, params.pageType);
    }
    if (params.pageSubType) {
        res.setHeader(models_1.ShoppingPortalHeadersEnum.PageSubType, params.pageSubType);
    }
    if (params.pageTypeId) {
        res.setHeader(models_1.ShoppingPortalHeadersEnum.PageTypeId, params.pageTypeId);
    }
    if (params.pageFooterStyle) {
        res.setHeader(models_1.ShoppingPortalHeadersEnum.PageFooterStyle, params.pageFooterStyle);
    }
};
exports.writeShoppingPortalResponseHeaders = writeShoppingPortalResponseHeaders;
const getDeviceType = (deviceAttributes = '', cookie = '') => {
    const deviceAttributesArr = deviceAttributes.split(',');
    let deviceType;
    for (let attribute of deviceAttributesArr) {
        attribute = (0, trim_1.default)(attribute.toUpperCase());
        if (Object.values(models_1.DeviceType).includes(attribute)) {
            deviceType = attribute;
        }
    }
    const mShopCookie = 'amzn-app-ctxt';
    if ((0, exports.isValidCookie)(mShopCookie, cookie) && (deviceType == models_1.DeviceType.Tablet || deviceType == models_1.DeviceType.Mobile)) {
        deviceType = models_1.DeviceType.MShop;
    }
    return deviceType || null;
};
exports.getDeviceType = getDeviceType;
const getPlatformType = (deviceAttributes = '') => {
    const deviceAttributesArr = deviceAttributes.split(',');
    let platformType;
    for (let attribute of deviceAttributesArr) {
        attribute = (0, trim_1.default)(attribute.toUpperCase());
        if (Object.values(models_1.PlatformType).includes(attribute)) {
            platformType = attribute;
        }
    }
    return platformType || null;
};
exports.getPlatformType = getPlatformType;
const isValidCookie = (name, cookie) => {
    const match = cookie && cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return !!match;
};
exports.isValidCookie = isValidCookie;
const getWeblabOverrideHeader = (req) => {
    if (req && req.headers[models_1.ShoppingPortalHeadersEnum.WeblabOverride]) {
        return {
            [models_1.ShoppingPortalHeadersEnum.WeblabOverride]: req.headers[models_1.ShoppingPortalHeadersEnum.WeblabOverride]
        };
    }
    return {};
};
exports.getWeblabOverrideHeader = getWeblabOverrideHeader;
